'use strict';

var angular = require('angular');


module.exports = angular
	.module('flxChannelLive', [])
	.directive('flxChannelLive', require('./flxChannelLiveDirective'));